import { Spinner as SpinnerComponent } from "reactstrap";

const Spinner = ({ isLoading, text, size = "sm", ...rest }) => {
  if (!isLoading) return null;

  const spinnerSize = size === "lg" ? "sm" : size;

  return (
    <div
      style={{
        zIndex: 1000,
        position: "absolute",
        inset: 0,
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        background: "rgba(241, 241, 241, 0.85)",
        borderRadius: "4px",
      }}
    >
      <SpinnerComponent
        size={spinnerSize}
        color="primary"
        style={size === "lg" ? { transform: "scale(1.5)" } : {}}
        {...rest}
      />
      <span style={{ fontSize: 14 }}>{text ?? "Loading"}</span>
    </div>
  );
};

export default Spinner;
